import { useState } from 'react'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import { InfoOutline } from '@vedmarket/ui-kit'

import {COLORS} from '../../../config/constants'

const CustomTooltip = ({content, sx, isWarning} : CommonTooltipProps) => {
  const [ isTooltipOpened, setIsTooltipOpened ] = useState(false)

  const openTooltip = () => setIsTooltipOpened(true)

  const closeTooltip = () => setIsTooltipOpened(false)

  return (
    <ClickAwayListener onClickAway={closeTooltip}>
      <Tooltip
        placement='top'
        open={isTooltipOpened}
        // // PopperProps={{ disablePortal: true }}
        // disableFocusListener
        // disableHoverListener
        // disableTouchListener
        title={content}
        arrow
      >
        {isWarning ? <IconButton
          data-demo-allowed='informer'
          aria-label={typeof content === 'string' ? content : undefined}
          onClick={openTooltip}
          sx={{padding: 0, width: 24, height: 24, color: COLORS.WARNING, ...sx}}
        >
          <InfoOutline style={{color: 'inherit'}}/>
        </IconButton> : <span data-demo-allowed='informer' style={{display: 'inline-flex', alignItems: 'center', ...sx}}>
          <InfoOutline onClick={openTooltip} style={{color: COLORS.LIGHT_ACTION}}/>
        </span>}
      </Tooltip>
    </ClickAwayListener>
  )
}

export default CustomTooltip
